import errorHandling from './error-handling';

export default class ProfessionalLogin {
	constructor({ elements }) {
		elements.forEach((el) => {
			const loginBtn = el.querySelector('.btn-login');

			loginBtn.addEventListener('click', (e) => {
				e.preventDefault();
				const submitBtns = Array.from(document.querySelectorAll('button[type="submit"]'));

				submitBtns.forEach((btn) => {
					const submitBtn = btn;
					submitBtn.disabled = true;
				});

				const validationElements = el.querySelectorAll('[data-validation]');

				if (errorHandling(validationElements)) {
					el.submit();
				} else {
					submitBtns.forEach((btn) => {
						const submitBtn = btn;
						submitBtn.disabled = false;
					});
				}
			});
		});
	}
}
